import { generateClassName } from '@klv/shared/utils/functions';
import { SingleLineForm } from '@klv/atoms/single-line-form';
import * as styles from '@klv/organisms/homepage-hero/styles/homepageHero.module.css';


import * as s from './styles';
import type { IHomepageHero } from './types';
import ContentCta from '../../molecules/content-cta';
import GradientFlagIcon from '../../atoms/gradient-flag-icon';

const Hero = ({
  children,
  ctaContent,
  heroContent,
}: IHomepageHero) => (
  <s.StyledHeroWrapper>
    <s.StyledHero>
      <s.HeroIconWrapper>
        <GradientFlagIcon/>
      </s.HeroIconWrapper>
      {heroContent?.gradientHeadline?.headline && (
        // no forwardedAs. Stakeholders want the h1 to be in content cta
        <s.HeroHeadline
          colorVariant='light'
          variant='display3'
          dangerouslySetInnerHTML={{ __html: heroContent.gradientHeadline.headline }}
        />
      )}
      {heroContent?.subheader && (
        <s.HeroSubheader
          variant='paragraph2'
          dangerouslySetInnerHTML={{ __html: heroContent.subheader }}
        />
      )} 
      {heroContent?.buttons && !heroContent?.showSingleLineForm && (  
        <s.StyledButtons
          buttonColor="light"
          variants={['primary', 'ghost']}
          buttons={heroContent.buttons}
        />
      )}
      {
        heroContent?.showSingleLineForm && (
          <s.FadeInForm>
          <SingleLineForm
            primaryButtonText={heroContent?.singleLineForm?.primaryButtonText}
            buttons={heroContent?.buttons}
            placeholderText={heroContent?.singleLineForm?.placeholderText}
          />
          </s.FadeInForm>
        )
      }
    </s.StyledHero>
    {heroContent?.image ? (
      <div className={generateClassName([styles.image, styles.fadeInUp])}
        style={{ backgroundImage: `url(${heroContent?.image?.publicUrl})`, marginBottom: 0 }}
      />
    ) : <s.CustomImageContainer/> }
    
    <s.StyledHero>
      <ContentCta
        buttons={ctaContent.buttons}
        headline={ctaContent.headline}
      />
    </s.StyledHero>
    {children ? (
      <s.StyledHero>
        {children}
      </s.StyledHero>
    ) : null}
  </s.StyledHeroWrapper>
);

export default Hero;
